import BaseLineup from 'services/sports/default/base-lineup';
import {round} from 'helpers/number-helper';
import Const from 'constants';

export default class Lineup extends BaseLineup {
    setPlayersByColumns({incomingValues: {team}}) {
        let captain = null,
            constructor = null;
        const drivers = [];

        team.map((player) => {
            if (player.getIsCaptain()) {
                captain = {...player, positionInLineup: 'CPT', positionIdInLineup: 'CPT'};
            } else if (player.lineupRole === 'D') {
                drivers.push({...player, positionInLineup: 'D', positionIdInLineup: 'D'});
            } else if (player.lineupRole === 'CNSTR') {
                constructor = {...player, positionInLineup: 'CNSTR', positionIdInLineup: 'CNSTR'};
            }
        });

        return [captain, ...drivers, constructor];
    }

    sumPlayersProperty({incomingValues: {players, prop}}) {
        let result = 0;
        players.map((player) => {
            result += Number(player.getCapPropValue(prop));
        });

        return result;
    }

    sumPlayersRoundedProperty({incomingValues: {players, prop, decimalPlacesCount = 0}}) {
        return players.reduce((propSum, player) => {
            const propValue = Number(player.getCapPropValue(prop));

            return propSum + round(propValue, decimalPlacesCount);
        }, 0);
    }

    prepareAllNotExcludedPlayersForExposureBox({incomingValues: {players, sportConfig}}) {
        const result = [];
        players.map((sketchyPlayer) => {
            const positions = sketchyPlayer.isDriver()
                ? [Const.CAPTAIN_MODE, sketchyPlayer.positionName]
                : [sketchyPlayer.positionName];

            positions.map((lineupRole) => {
                const player = cp(sketchyPlayer);

                player.usedLineupsCount = 0;
                player.lineupRole = lineupRole;

                result.push(player);
            });
        });

        return result;
    }

    combineOptimizedAndNotExcludedPlayers({incomingValues: {optimizedPlayers, notExcludedPlayers, sportConfig}}) {
        return this.exec('combineOptimizedAndNotExcludedPlayersByLineupRole', {
            optimizedPlayers,
            notExcludedPlayers,
        });
    }

    recalculateLineupsUsedPlayers({incomingValues: {lineups}}) {
        return this.exec('recalculateLineupsUsedPlayers_ShowDown', {lineups});
    }
}
